const AVATAR_SIZE = {
  height: 160,
  width: 160,
};

export default AVATAR_SIZE;
